module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"New Account":"Neuer Account","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Owner":"Inhaber","Account list could not be fetched.":"Benutzerliste konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
